import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { DateTime } from "components/common/Date";
import { useSupplierOverview } from "./SupplierOverviewContext";

const OverviewTab = () => {
  const { supplier } = useSupplierOverview();

  return (
    <Row>
      <Col lg={8}>
        <Card>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-3 text-uppercase">Supplier info</h6>
              <div className="table-responsive">
                <Table className="table-borderless mb-0">
                  <tbody>
                    {supplier?.code && (
                      <tr>
                        <th
                          className="ps-0"
                          scope="row"
                          style={{ width: "180px" }}
                        >
                          Code :
                        </th>
                        <td className="text-muted">{supplier.code}</td>
                      </tr>
                    )}
                    <tr>
                      <th className="ps-0" scope="row">
                        Email :
                      </th>
                      <td className="text-muted">{supplier?.email ?? "—"}</td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Phone :
                      </th>
                      <td className="text-muted">{supplier?.phone ?? "—"}</td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Address :
                      </th>
                      <td className="text-muted">{supplier?.address ?? "—"}</td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        City / State :
                      </th>
                      <td className="text-muted">
                        {[supplier?.city, supplier?.state]
                          .filter(Boolean)
                          .join(", ") || "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        GST :
                      </th>
                      <td className="text-muted">{supplier?.gstNumber ?? "—"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              <div className="pt-3 border-top border-top-dashed mt-4">
                <Row className="gy-3">
                  {supplier?.created_at && (
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">Created</p>
                        <h5 className="fs-14 mb-0">
                          <DateTime date={supplier.created_at} />
                        </h5>
                      </div>
                    </Col>
                  )}

                  {supplier?.updated_at && (
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          Last updated
                        </p>
                        <h5 className="fs-14 mb-0">
                          <DateTime date={supplier.updated_at} />
                        </h5>
                      </div>
                    </Col>
                  )}

                  <Col lg={3} sm={6}>
                    <div>
                      <p className="mb-2 text-uppercase fw-medium">Status :</p>
                      <h5 className="fs-14 mb-0">
                        {supplier?.isActive === false ? (
                          <span className="badge bg-danger-subtle text-danger">
                            Inactive
                          </span>
                        ) : (
                          <span className="badge bg-success-subtle text-success">
                            Active
                          </span>
                        )}
                      </h5>
                    </div>
                  </Col>

                  {supplier?.deleted_at != null && supplier.deleted_at !== "" ? (
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium text-danger">
                          Deleted
                        </p>
                        <h5 className="fs-14 mb-0 text-danger">
                          <DateTime date={supplier.deleted_at} />
                        </h5>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default OverviewTab;
